// collectorGenerator.js
var CollectorGenerator = pc.createScript('collectorGenerator');

CollectorGenerator.attributes.add('planetInfo', {type: 'entity'});


// initialize code called once per entity
CollectorGenerator.prototype.initialize = function() {
    this.app.on('uiGenerator:CollectorGenerator:triggerCollectorText', this.genCollectorText, this);
    this.app.on('uiGenerator:collectorGenerator:turnOff', this.turnOff, this);

    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.piScript = this.app.root.children[0].script.planetInfoGenerator;
    this.planetList = this.piScript;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    this.theText = '';
    this.bakTxt = '';

    this.fs = [
        ' IS AN IMPORTANT FIGURE OF ',
        ' IS A FAMOUS INDIVIDUAL OF ',
        ' IS A LEADING INDIVIDUAL OF ',
        ' IS A PROMINENT HEAD OF ',
        ' PLAYS AN IMPORTANT ROLE IN ',
        ' IS AN AMBASSADOR FOR '
        ];
        
    this.pos = [
        ' THE POLITCAL ESTABLISHMENT.',
        ' THE PLANETARY GOUVERNMENT.', 
        ' THE HOLO DRAMA INDUSTRY.',
        ' A WIDLY FEARED UNDERWORLD SYNDICATE.',
        ' THE PLANETARY ECONOMIC ELITE.',
        ' INTERPLANETARY PROFESSIONAL SPORTS.'
        ];

    this.gg = [
        ' IS A POWERFUL PERSON THAT HOLDS THE RIGHTS FOR MINING THIS GASPLANET.',
        ' IS PRESIDENT OF THE TRADE CONSORTIUM THAT OWNS THIS PLANET.',
        ' IS A GALACTIC QUINTILLIONAIRE WHO BOUGHT THIS PLANET FOR NO PARTICULAR REASON.',
        ' IS THE PROUD OWNER OF THIS GASBALL.',
        ' IS HEAD OF AN ORGANIZATION BIDDING FOR THIS PLANETS MINING CONESSION'
    ];

    this.er = [
        ' AND A INTERGALACTIC ORGANIZATION HAVE AMBITIOUS PLANS TO DEVELOPE THIS DESERTED ROCK.',
        ' HAS WON THIS PLANET BY GAMBLING AT PER MELHELE II AND NOW WONDERS WHAT TO DO WITH IT.',
        ' BOUGHT THIS PLANET TO BUILD A SECRET UNDERGROUND BASE.',
        ' IS THE PROUD OWNER OF THIS PLANETARY DESERT.',
        ' PLANS TO BUILD A VERY OWN CIVILIZATION RIGHT HERE, BUT LACKS OF ACTUAL PEOPLE.',
        ' IS A PECULIAR HERMIT LIVING ON THIS DESERETED DUSTBALL',
        ' WOKE UP AFTER A NIGHT IN A BAR AT AD TULMELE III AND WAS OWNER OF A WHOLE PLANET. WITHOUT REMEMBRANCE.'
    ];

};

CollectorGenerator.prototype.setMulti = function(){

    this.fs = [
        ' IS AN IMPORTANT ORGANIZATION OF',
        ' - A FAMOUS COMPANY FOR',
        ' IS A LEADING INSTITUTION IN',
        ' - A INFAMOUS CONGLOMERATE OF',
        ' - A CONSORTIUM THAT PLAYS AN IMPORTANT ROLE FOR',
        ' IS THE NAME OF A SYNDICATE IN',
        ' - A GROUP OF INDIVIDUALS FROM',
        ' ARE A GROUP OF CONSPIRATORS FROM'
        ];
        
    this.pos = [
        ' THE GALACTIC COMMONWEALTH.',
        ' THE REGIONAL QUADRANTS.', 
        ' THE GREAT TRADE ROUTE.',
        ' THE GREAT RIFT.',
        ' THE DOMINION SYSTEMS.',
        ' THE GREAT GALACTIC DEMARCHY.'
        ];

    this.gg = [
        ' - A COMMERCIAL OPERATION THAT HAS BOUGHT THE MINING RIGHTS FOR THIS PLANET.',
        ' IS A CONSORTIUM THAT HAS ACQUIRED THIS PLANET.',
        ' - A GROUP OF QUINTILLIONAIRES THAT HAS BOUGHT THIS PLANET OUT OF PURE DECADENCE.',
        ' ARE THE PROUD OWNER OF THIS GASBALL.',
        ' IS AN ORGANIZATION THAT POSESSES THIS GASGIANT.'
    ];

    this.er = [
        ' IS AN INTERGALACTIC ORGANIZATION HAVING AMBITIOUS PLANS TO DEVELOPE THIS DESERTED ROCK.',
        ' IS A GROUP OF INDIVIDUALS THAT HAS WON THIS PLANET IN A SWEEPSTAKES AND NOW WONDERS WHAT TO DO WITH IT.',
        ' - A SYNDICATE WHICH BOUGHT THIS PLANET TO BUILD A SECRET UNDERGROUND BASE.',
        ' IS THE PROUD OWNER OF THIS PLANETARY DESERT.',
        ' - A CULT THAT WANTS TO BUILD THEIR VERY OWN CIVILIZATION RIGHT HERE, BUT STILL LACKS OF POPULATION.',
        ' ARE A GROUP OF PECULIAR HERMITS LIVING ON THIS DESERETED DUSTBALL'
    ];

};

CollectorGenerator.prototype.genCollectorText = function(tName, cnt, plnt, multi){

    if(multi){
        this.setMulti();
    }

    this.bakTxt = this.piScript.plntDesc[cnt-1];
    console.info(this.piScript.plntDesc[cnt-1]);
    console.log(this.bakTxt);
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);

    //console.info(plnt.children[1].script.planetGenerator.civilization);

    if(plnt.name !== 'gasGiant'){
        if(plnt.children[1].script.planetGenerator.civilization){
            this.theText = 'COLLECTOR:\n' + tName + this.fs[Math.floor(this.randomize() * this.fs.length)] + this.pos[Math.floor(this.randomize()*this.pos.length)];
            this.planetInfo.element.text = this.theText;
            return;
        }
    }

    if(plnt.name == 'habitable'){
        this.theText = 'COLLECTOR:\n' + tName + this.er[Math.floor(this.randomize() * this.fs.length)];
    }
    if(plnt.name == 'rockPlanet'){
        this.theText = 'COLLECTOR:\n' + tName + this.er[Math.floor(this.randomize() * this.fs.length)];
    }
    if(plnt.name == 'gasGiant'){
        this.theText = 'COLLECTOR:\n' + tName + this.gg[Math.floor(this.randomize() * this.fs.length)];
    }

    this.planetInfo.element.text = this.theText;

   
   // console.log(this.theText);
    

};

CollectorGenerator.prototype.turnOff = function(){
    console.log(this.bakTxt);
    this.planetInfo.element.text = this.bakTxt;//this.piScript.plntDesc[cntr];
};

// swap method called for script hot-reloading
// inherit your script state here
// CollectorGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

